<template>
    <div class="login-logo">
        <svg class="icon">
            <use xlink:href="#icon-erji"></use>
        </svg>
    </div>
</template>

<script>
    export default {
        name: "loginLogo"
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/login-logo";
</style>